/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../models/Node';

/**
 * All data model traversers must implement this interface.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface ITraverser {
    /**
     * Traverse a single node in a data model.
     * @param {Node} node
     */
    traverse(node : Node);
}


